

import { Component, Mixins } from 'vue-property-decorator';
import PopupMixin from '~common-mixins/PopupMixin';
import ActionReloader from '~common-components/Popup/Common/ActionReloader.vue';
import { DevicesModule } from '~/store/modules/devices';
import ContentDownloader from '~common-components/Popup/Common/ContentDownloader.vue';

@Component({
    components: {
        ActionReloader,
        ContentDownloader,
    },
})
export default class OperationLogsPopup extends Mixins(PopupMixin) {
    get currentGatewayId() {
        return DevicesModule.currentGatewayId;
    }
    async getLogs() {
        try {
            const data = await DevicesModule.currentGateway?.logs();
            await DevicesModule.setLogsValue(data);
        } catch (error) {
            await DevicesModule.setLogsValue([]);
        }
    }
    get fileName() {
        const macAddress = this.currentGatewayId.replace(/:/g, '_');
        return `logs-${macAddress}.txt`;
    }

    get logsValue() {
        return DevicesModule.logsValue;
    }
}
